export var wrapper = 'rounded-10 flex flex-row items-center px-4 py-6 sm:px-6 justify-between';
export var content = 'w-full flex flex-row justify-start items-center';
export var menuChevron = 'h-6 w-6 text-primary';
//# sourceMappingURL=score-card.styles.js.map